import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=28059662&scoped=true&lang=html&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=28059662&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28059662",
  null
  
)

component.options.__file = "phone.vue"
export default component.exports